module.exports = __webpack_public_path__ + "static/media/bio_480.026fd09e.png";